import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { SharedFunctions } from '../../../src/app/shared/shared.functions';

import { ParametroSistemaService, SeguridadService } from '../../../src/app/shared/services';
import { RegisterUsuarioDto } from '../../../src/app/shared/model';

@Component({
    selector: 'app-empadronamiento',
    templateUrl: './empadronamiento.component.html',
    styleUrls: ['./empadronamiento.component.css']
})

export class EmpadronamientoComponent implements OnInit {
    @ViewChild('input') input: ElementRef;
    formUserGroup: FormGroup;

    private entity: RegisterUsuarioDto;
    comunidadId: number;

    hide: boolean = true;
    hideConfirm: boolean = true;

    buttonEnabled: boolean = true;
    isValidating: boolean = false;
    isValid: boolean = false;
    mustWaitUserConfirm: boolean = false;
    existingUser: boolean = false;

    msgError: string = "";

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private sharedFunctions: SharedFunctions,
        private seguridadService: SeguridadService,
        private parametroSistemaService: ParametroSistemaService
    ) {
    }

    ngOnInit(): void {
        this.sharedFunctions.clearLocalStorage();
        this.buildUserForm();

        this.parametroSistemaService.getAnonymousCode("ConfirmarActivacionUsuariosNuevos").subscribe(response => {
            if (response && response.Success) {
                this.mustWaitUserConfirm = response.Result?.Valor ? (response.Result?.Valor?.toLowerCase() == "true" || response.Result?.Valor?.toLowerCase() == "1") : false;
            }
        }, 
        (err: HttpErrorResponse) => {
            this.sharedFunctions.handleError(err);
        });

        this.route.queryParams.subscribe(params => {
            if (params['tk'] != null && params['tk'].length > '0') {
                this.isValidating = true;
                this.seguridadService.processNewUserToken(params['tk']).subscribe(response => {
                    this.isValidating = false;
                    
                    if (response && response.Success) {
                        this.isValid = true;
                        this.existingUser = (response.Result?.UsuarioCreado ?? false);
                        this.comunidadId = (response.Result?.ComunidadId ?? 0);

                        this.formUserGroup.get("Nombre")?.setValue(response.Result?.Persona?.Nombre);
                        this.formUserGroup.get("Apellido")?.setValue(response.Result?.Persona?.Apellido);
                        this.formUserGroup.get("Mail")?.setValue(response.Result?.Persona?.MailContacto);
                    }
                }, 
                (err: HttpErrorResponse) => {
                    this.isValidating = false;
                    this.msgError = err?.error?.Message ?? "Ocurrió un error solicitando los datos al servidor.";
                    // this.sharedFunctions.handleError(err, true);
                });
            }
            else {
                this.msgError = "La URL no es válida";
                // this.sharedFunctions.showMessage("La URL no es válida", "Error");
            }
        });
    }

    buildUserForm() {
        this.formUserGroup = this.formBuilder.group({
            'Nombre': [null, [Validators.required, Validators.maxLength(150)]],
            'Apellido': [null, Validators.maxLength(150)],
            'NroDocumento': [null, Validators.maxLength(100)],
            'Mail': [null, [Validators.required, Validators.maxLength(255), Validators.email]],
            'Movil': [null, Validators.maxLength(100)],
            'Login': [null, [Validators.required, Validators.maxLength(100)]],
            'Clave': [null, [Validators.required, Validators.maxLength(100)]],
            'ConfirmClave': [null, [Validators.required, Validators.maxLength(100)]]
        });
    }

    getErrorNombre() {
        var v = this.formUserGroup.get('Nombre');
        if (v?.hasError('required'))
            return 'El campo es obligatorio';
        if (v?.hasError('maxlength'))
            return 'Límite de 150 caracteres alcanzado';
        return '';
    }

    getErrorApellido() {
        var v = this.formUserGroup.get('Apellido');
        if (v?.hasError('maxlength'))
            return 'Límite de 150 caracteres alcanzado';
        return '';
    }

    getErrorMail() {
        var v = this.formUserGroup.get('Mail');
        if (v?.hasError('required'))
            return 'El campo es obligatorio';
        if (v?.hasError('maxlength'))
            return 'Límite de 255 caracteres alcanzado';
        if (v?.hasError('email'))
            return 'Debe ingresar un email con formato válido';
        return '';
    }

    getErrorLogin() {
        var v = this.formUserGroup.get('Login');
        if (v?.hasError('required'))
            return 'El campo es obligatorio';
        if (v?.hasError('maxlength'))
            return 'Límite de 100 caracteres alcanzado';
        return '';
    }

    getErrorClave() {
        var v = this.formUserGroup.get('Clave');
        if (v?.hasError('required'))
            return 'El campo es obligatorio';
        if (v?.hasError('maxlength'))
            return 'Límite de 100 caracteres alcanzado';
        return '';
    }

    getErrorConfirmClave() {
        var v = this.formUserGroup.get('ConfirmClave');
        if (v?.hasError('required'))
            return 'El campo es obligatorio';
        if (v?.hasError('maxlength'))
            return 'Límite de 100 caracteres alcanzado';
        return '';
    }

    onCancelar() {
        this.router.navigate(['auth/login']);
    }

    onGuardar() {

        if (!this.formUserGroup.valid) {
            this.sharedFunctions.showMessage("Por favor completa todos los datos obligatorios marcados con asterisco" , "Error");
            return false;
        }

        var value = { ... this.entity, ... this.formUserGroup.getRawValue(), ComunidadId: this.comunidadId };

        if (value == null) {
            this.sharedFunctions.showMessage("Debe completar todos los campos para continuar con la operación", "Error");
            return false;
        }

        if (value.Clave != value.ConfirmClave) {
            this.sharedFunctions.showMessage("La clave ingresada y su confirmación son distintas", "Error");
            return false;
        }

        this.buttonEnabled = false;
        this.seguridadService.registerUser(value).subscribe(data => {
            this.buttonEnabled = true;
            if (data.Success) {
                var msg = "Se cargaron exitosamente los datos de tu usuario. Vas a recibir un correo en la casilla de mail que ingresaste previamente y " +
                    "la cual se utilizará para comunicarnos con vos en adelante.";
                if (this.mustWaitUserConfirm)
                    msg += "Por el momento aguarda mientras validamos la información que ingresaste para poder utilizar el sistema. Te avisaremos por mail cuando finalicemos.";

                this.sharedFunctions.showMessage(msg, "Operación Exitosa!");
                this.onCancelar();
            } else {
                this.sharedFunctions.showMessage("Ocurrió un error generando el usuario. Vuelva a intentarlo por favor", "Error");
            }
        },
        (err: HttpErrorResponse) => {
            this.buttonEnabled = true;
            this.sharedFunctions.handleError(err, true);
        });
    }
}